import { useCallback, useState } from 'react'

// notice: fn is better to be not changed always when re-render
function useMutation<T, M>(fn: (m: M) => Promise<T>) {
  const [data, setData] = useState<T | undefined>(undefined)
  const [error, setError] = useState<any>(undefined)
  const [loading, setLoading] = useState(false)

  const run = useCallback(
    async (m: M, onSuccess?: (d: T) => void, onFail?: (err: any) => void) => {
      try {
        setLoading(true)
        const res = await fn(m)
        setData(res)
        onSuccess?.(res)
      } catch (err) {
        setError(err)
        onFail?.(err)
      } finally {
        setLoading(false)
      }
    },
    [fn]
  )

  return { data, error, loading, run }
}

export { useMutation }
